import React, { Component } from 'react';
import $ from 'jquery';

class ConfirmModalCartaPorte extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#confirmModalCartaPorte').modal('hide');
    }

    closeAction = () => {

        $('#confirmModalCartaPorte').on('hidden.bs.modal', function () {
        });
    };
    render() {
        const { CloseDocumentModal } = this.props;
        return (
            <div className="modal" tabIndex="-1" role="dialog" id="confirmModalCartaPorte" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">

                        <div className="modal-body">
                            <p>¿Está seguro que deseas eliminar este registro?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" data-dismiss="modal" onClick={() => CloseDocumentModal()}>Confirmar</button>
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
export default ConfirmModalCartaPorte;